module.exports = __webpack_public_path__ + "static/media/03_eastern_lowland_gorilla.bceb9f59.png";